// extracted by mini-css-extract-plugin
export default {"defaultStyles":"DiffFind-module__defaultStyles--HqMRo"};